/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Box, Button, Flex, Text, useToast } from '@chakra-ui/react';
import { ArrowBackIcon, AddIcon } from '@chakra-ui/icons';
import ReusableTable from 'components/ReusableTable';
import SystemAxisMappingForm from './systemAxisMappingForm';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import useDebounce from 'constants/helper/useDebounce';
import { getSystemAxisMappingList } from 'api/auth.api';

function SystemAxisMapping() {
  const queryClient = useQueryClient();

  const [showForm, setShowForm] = useState(false);

  const [page, setPage] = useState(1);
  const [searchString, setSearchString] = useState('');
  const debouncedSearchTerm = useDebounce(searchString, 1000, setPage);
  const toast = useToast();

  const [selectedId, setSelectedId] = useState(null);

  const payload = {
    searchString: debouncedSearchTerm,
    page,
  };

  const { data, isFetching, error, isSuccess, isError } = useQuery({
    queryKey: ['getSystemAxisMappingList', debouncedSearchTerm, page],
    queryFn: () => getSystemAxisMappingList(payload),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Failed to fetch system axis list',
        description: error?.message || 'Something went wrong',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });
    }
  }, [isError, error, toast]);

  const tableData = data?.data?.result?.map((item, index) => ({
    ...item,
    srNo: (page - 1) * 20 + index + 1, // 10 = pageSize
    axisName: item.systemId?.name || '',
  }));

  return (
    <Box p={4} mt={10}>
      {/* TABLE VIEW */}
      {!showForm && (
        <ReusableTable
          data={tableData}
          columns={[
            { key: 'srNo', label: 'Sr.No', width: '80px', headerSize: '14px' },
            {
              key: 'diseaseEN',
              label: 'Disease Name',
              width: '200px',
              headerSize: '14px',
            },
            {
              key: 'diseaseHN',
              label: 'रोग का नाम',
              width: '200px',
              headerSize: '14px',
            },
            {
              key: 'axisName',
              label: 'Axis Name',
              width: '200px',
              headerSize: '14px',
            },
            {
              key: 'axisCode',
              label: 'Axis Code',
              width: '200px',
              headerSize: '14px',
            },
          ]}
          page={page}
          totalPages={data?.data?.totalPages || 1}
          loading={false}
          onRowClick={() => {}}
          onEdit={(id) => {
            setSelectedId(id);
            setShowForm(true);
          }}
          onPageChange={(newPage) => setPage(newPage)}
          showTopAction={true}
          showSearch={true}
          onSearch={(value) => {
            setSearchString(value);
            setPage(1);
          }}
          topAction={{
            title: 'System Axis Mapping Page',
            label: 'Add Mapping',
            icon: <AddIcon />,
            onClick: () => setShowForm(true),
          }}
          showViewToggle={false}
        />
      )}

      {/* FORM VIEW */}
      {showForm && (
        <Box w="100%">
          {/* BACK BUTTON + HEADING ROW */}
          <Flex
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <Text fontSize="22px" fontWeight="bold" ml={3}>
              System Axis Mapping Form
            </Text>
            <Button
              variant="ghost"
              leftIcon={<ArrowBackIcon />}
              onClick={() => setShowForm(false)}
            >
              Back
            </Button>
          </Flex>

          {/* FORM (FULL WIDTH) */}
          <SystemAxisMappingForm
            editId={selectedId}
            onSuccess={() => {
              queryClient.invalidateQueries(['getSystemAxisMappingList']);
              setShowForm(false);
            }}
          />
        </Box>
      )}
    </Box>
  );
}

export default SystemAxisMapping;
